import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import loginActions from "../login/duck/actions";
import axios from "../common/axios";
import { API_URL } from "./constants";

const ENDPOINT = API_URL + "/v1/auth/signup/invite/";

function getPlatformInviteMetadata() {
  const platformInviteMetadata = localStorage.getItem("platformInviteMetadata");

  if (!platformInviteMetadata) {
    return null;
  }

  try {
    return JSON.parse(platformInviteMetadata);
  } catch (err) {
    return null;
  }
}

export function getPlatformInviteFirstName() {
  const metadata = getPlatformInviteMetadata();
  if (!metadata || !Object.keys(metadata).length) {
    return;
  }
  return metadata.firstName;
}

function usePlatformInvite() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => Boolean(state.user?.profile?._id));

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(loginActions.setPlatformInvite(null));
    } else if (localStorage.getItem("platformInvite")) {
      dispatch(
        loginActions.setPlatformInvite(localStorage.getItem("platformInvite"))
      );
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      localStorage.removeItem("platformInvite");
      localStorage.removeItem("platformInviteMetadata");
      dispatch(loginActions.setIsPlatformInviteLoading(false));
      dispatch(loginActions.setPlatformInvite(null));
      return;
    }

    const query = new URLSearchParams(window.location.search);
    const platformInvite = query.get("platform_invite");

    if (!platformInvite) {
      dispatch(loginActions.setIsPlatformInviteLoading(false));
      return;
    }

    localStorage.setItem("platformInvite", platformInvite);
    dispatch(loginActions.setPlatformInvite(platformInvite));
    dispatch(loginActions.setIsPlatformInviteLoading(true));

    axios
      .get(`${ENDPOINT}${platformInvite}`)
      .then((response) => {
        if (response && response.data && Object.keys(response.data).length) {
          localStorage.setItem(
            "platformInviteMetadata",
            JSON.stringify(response.data)
          );
        } else {
          throw new Error("Couldn't get metadata for the invitee");
        }
      })
      .catch(() => {
        localStorage.removeItem("platformInvite");
        localStorage.removeItem("platformInviteMetadata");
        dispatch(loginActions.setPlatformInvite(null));
      })
      .finally(() => {
        dispatch(loginActions.setIsPlatformInviteLoading(false));
      });
  }, [dispatch, isLoggedIn]);
}

export default usePlatformInvite;
